import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CONSTANT_PRODUCT_TYPE_INFOS } from '../../../../../../shared/constantProductTypeInfos';
import { SellerNameSaverService } from '../../../../services/seller-name-saver.service';
import { GetCalculatesParamsService } from '../../../../services/get-calculates-params.service';
import { PatternService } from '../../../../services/pattern.service';
import { FetchPageService } from '../../../../services/fetch-page.service';
import { SeoService } from '../../../../services/seo.service';
import { ProductExtraInfos } from '../../../../buyer';
import { Observable, Subscription, from } from 'rxjs';
import Cookies, { CookieAttributes }  from 'js-cookie';
import { ValidateSourceService } from 'src/app/public-website/public/services/source-validate.service';

@Component({
  selector: 'app-buyer-container',
  templateUrl: './buyer-container.component.html',
  styleUrls: ['./buyer-container.component.scss'],
})
export class BuyerContainerComponent implements OnInit, OnDestroy {
  pattern: string = '';
  isProduct: boolean = false;
  isShop: boolean = false;
  productObject: any;
  productsList: any;
  businessObject: any;
  available: boolean = true;
  unavilabilityReason: string;
  errorMessage: string;
  sellerName: string;
  $queryParams: Subscription

  constructor(
    private activatedRoute: ActivatedRoute,
    private fetchPageService: FetchPageService,
    private validateSourceService: ValidateSourceService,
    private seoService: SeoService,
    private patternService: PatternService,
    private getCalculatesParamsService: GetCalculatesParamsService,
    public SellerNameSaver: SellerNameSaverService
  ) {
    this.pattern = this.activatedRoute.snapshot.params.pattern;
    this.patternService.getPattern(this.pattern);
  }
  ngOnDestroy(): void {
    this.$queryParams?.unsubscribe();
  }

  async ngOnInit() {
    this.trackData();
    await this.fetchPage();
  }

  private normalizeProduct(productObject: any) {
    
    let productExtraInfoName = this.mapExtraInfoByProductType(
      productObject.ProductType.name
    );
    if (productObject.ProductType.name == 'Quick Payment') {
      return {
        slug: productObject.code,
        name: productObject['productName'],
        description: this.getProductByExtraInfoValue(
          'description',
          this.productObject['QuickPaymentExtraInfos']
        ),
        image: productObject.Business.logo,
      };
    } else {
      return {
        slug: productObject.code,
        name: productObject['productName'],
        description: this.getProductByExtraInfoValue(
          'description',
          productObject['ProductExtraInfos']
        ),
        image: productObject.Business.logo,
      };
    }
  }

  private normalizeShop(shopObject: any) {
    return {
      slug: shopObject.name,
      name: shopObject.name,
      description: shopObject.description,
      image: shopObject.logo,
    };
  }

  private mapExtraInfoByProductType(productType: string) {
    switch (productType) {
      case CONSTANT_PRODUCT_TYPE_INFOS.PRODUCT_TYPES.PHYSICAL:
        return CONSTANT_PRODUCT_TYPE_INFOS.EXTRA_INFO.PHYSICAL;
      case CONSTANT_PRODUCT_TYPE_INFOS.PRODUCT_TYPES.INVOICE:
        return CONSTANT_PRODUCT_TYPE_INFOS.EXTRA_INFO.INVOICE;
      case CONSTANT_PRODUCT_TYPE_INFOS.PRODUCT_TYPES.Event:
        return CONSTANT_PRODUCT_TYPE_INFOS.EXTRA_INFO.Event;
      case CONSTANT_PRODUCT_TYPE_INFOS.PRODUCT_TYPES.Calendar:
        return CONSTANT_PRODUCT_TYPE_INFOS.EXTRA_INFO.Calendar;
      case CONSTANT_PRODUCT_TYPE_INFOS.PRODUCT_TYPES.QUICK_CASH:
        return CONSTANT_PRODUCT_TYPE_INFOS.EXTRA_INFO.QUICK_CASH;
      case CONSTANT_PRODUCT_TYPE_INFOS.PRODUCT_TYPES.QUICK_PAYMENT:
        return CONSTANT_PRODUCT_TYPE_INFOS.EXTRA_INFO.QUICK_PAYMENT;
      case CONSTANT_PRODUCT_TYPE_INFOS.PRODUCT_TYPES.Reservation:
        return CONSTANT_PRODUCT_TYPE_INFOS.EXTRA_INFO.Reservation;
      default:
        return CONSTANT_PRODUCT_TYPE_INFOS.EXTRA_INFO.PHYSICAL;
    }
  }

  private getProductByExtraInfoValue(
    fieldName: string,
    productExtraInfos: Array<ProductExtraInfos>
  ) {
    for (const field of productExtraInfos) {
      if (field.key === fieldName) {
        return field.value;
      }
    }
    return undefined;
  }

  async trackData(){
     this.$queryParams = this.activatedRoute.queryParams.subscribe(async params => {      
      try{
        const prodId: String = params['c'];
        const source: String = params['s'];
        if(!prodId || !source) return;
        
          let existingData: [{prodId: String, source: String}];
          const localStorageData = JSON.parse(localStorage.getItem('trackingData') || '[]');
          const cookieData = JSON.parse(Cookies.get('trackingData') || '[]');
          
          if(localStorageData.length >= cookieData.length) { 
            existingData = localStorageData;
          } else {
            existingData = cookieData;
          }
  
          const vSource = await this.validateSource(source);
          
          const newData = { prodId: prodId, source: vSource };
          if(!existingData.some(item => item.prodId === prodId && item.source === source)){
  
            existingData.push(newData);
                  
            localStorage.setItem('trackingData', JSON.stringify(existingData));
    
            const cookieAttributes: CookieAttributes = { expires: 7, path: '/' };
            Cookies.set('trackingData', JSON.stringify(existingData), cookieAttributes);
          }
        
      } catch (err) {
        console.log(err);
      }
    })
  }

  async validateSource(source: String) {
    let validSource; 
    this.validateSourceService.setParams({
      sourceId: source,
    });
    try {
      const result = await this.validateSourceService.make();
      if(result.valid){
        validSource = source
        return validSource;
      } else {
        validSource = result.defaultSourceId;
        return validSource;
      }
    } catch (err) {
      console.log(err);
    }
  }

  async fetchPage() {
    try {
      this.fetchPageService.setParams({
        code: this.pattern,
      });
      const resultObservable = await this.fetchPageService.make();
        if (resultObservable.available) {
          this.productObject = resultObservable.product;
          if (resultObservable.isProduct) {
            const currentObject = this.normalizeProduct(this.productObject);
            this.seoService.generateTags({
              title: `${currentObject.name} | EasyKash`,
              description: currentObject.description,
              slug: currentObject.slug,
              image: currentObject.image,
            });
          }
        } else if (resultObservable.isShop) {
          this.businessObject = resultObservable.business;
          const currentObject = this.normalizeShop(this.businessObject);
          this.seoService.generateTags({
            title: `${currentObject.name} | EasyKash`,
            description: currentObject.description,
            slug: currentObject.slug,
            image: currentObject.image,
          });
        }
        this.getCalculatesParamsService.limit = resultObservable.limit;
        this.available = resultObservable.available;
        if (this.available == null) this.available = true;

        //in case of Product we need check if that product available
        //not to include it with business shop view
        if (resultObservable.isProduct) {
          //custom payment comes with product true and no details
          //which trigger product not avail
          if (!this.available) {
            if (!this.isProductAvailable(resultObservable)) {
              this.errorMessage = `
              The product you are checking is currently unavailable because
              it is ${this.unavilabilityReason} by ${this.sellerName}. \n
              Please contact ${this.sellerName} for a fresh working link
            `;
              this.available = false;
              return;
            }
          }
        }

        if (this.available == true) {
          this.SellerNameSaver.pattern = this.pattern;
          if (resultObservable.isProduct) {
            this.isProduct = true;
            this.isShop = false;
            this.getCalculatesParamsService.setProductId(resultObservable.product.id);
          } else if (resultObservable.isShop) {
            this.productsList = resultObservable.products;
            this.isShop = true;
            this.isProduct = false;
            const currentObject = this.normalizeShop(this.businessObject);
          } else {
            throw new Error('unKnown Page! unnecessary');
          }
        } else {
          this.SellerNameSaver.sellerName = resultObservable.product.Business.name;
        }
      
    } catch (err) {
      console.log(err);
    }
  }

  isProductAvailable(result: Result): boolean {
    if (
      !result.product.published ||
      result.product.deletedAt ||
      new Date(result.product.expiryDate) < new Date()
    ) {
      this.sellerName = result.product.Business.name;
      !result.product.published
        ? (this.unavilabilityReason = 'unpublished')
        : null;
      result.product.deletedAt ? (this.unavilabilityReason = 'deleted') : null;
      new Date(result.product.expiryDate) < new Date()
        ? (this.unavilabilityReason = 'expired')
        : null;
      return false;
    } else {
      return true;
    }
  }
}

interface Result {
  product: {
    expiryDate: string;
    deletedAt: string;
    published: boolean;
    Business: {
      name: string;
    };
  };
  [key: string]: any;
}
